import { createTheme } from '@mui/material';

//#f1f1f1 - cinza claro
//#867b75 - cinza escuro
// Create a custom theme
export default createTheme({
    palette: {
        primary: {
            main: '#d3ead8', // primary color - verde
            contrastText: '#265d25' // text color for primary
        },
        secondary: {
            main: '#e3e8ee', // secondary color - azul
            contrastText: '#3176ba' // text color for secondary
        },
        other: {
            main: '#f1f1f1',
            contrastText: '#867b75'
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontSize: '16px',            // Global font size for all buttons
                    textTransform: 'capitalize', // Global text transformation for all buttons
                    border: '1px solid',         // Global border style for all buttons
                    '&.MuiButton-contained': {
                        boxShadow: 'none'
                    }
                },
                containedPrimary: {
                    borderColor: '#c0d8c5',         // Specific border color for primary buttons
                    '&:hover': {
                        backgroundColor: '#88c695' // Darker background on hover for primary
                    }
                },
                containedSecondary: {
                    borderColor: '#ced6df',        // Specific border color for secondary buttons
                    '&:hover': {
                        backgroundColor: '#9badc2' // Darker background on hover for secondary
                    }
                },
                containedOther: {
                    '&:hover': {
                        backgroundColor: '#c1c1c1' // Darker background on hover for secondary
                    }
                },
                outlinedPrimary: {
                    color: '#4c7035',
                    '&:hover': {
                        backgroundColor: '#f1f1f1' // Darker background on hover for secondary
                    }
                }
            }
        }
    }
});
